import { Typography } from "@mui/material";
import { max } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import ScatterAndLineOfBestFit from "../ScatterAndLineOfBestFit";
import EmptyBoard from "./EmptyBoard";

import RegressionInfo from "./RegressionInfo";

function CorrelationBoard({
  data,
  quantitativeLabelsChecked,
  table,
  selectedLabels,
  labelOpacity,
  setLabelOpacity,
  thumbnail,
}) {
  const { t } = useTranslation();

  const firstLabel = quantitativeLabelsChecked?.[0] ?? { id: "", label: "" };
  const firstLabelId = firstLabel.id;
  const firstLabelTitle = firstLabel.label;
  const secondLabel = quantitativeLabelsChecked?.[1] ?? { id: "", label: "" };
  const secondLabelId = secondLabel.id;
  const secondLabelTitle = secondLabel.label;

  const correlationAnalysis = window.correlationAnalysis;
  const values = data
    .map((beep) =>
      beep.table.filter(
        (row) => row.id === firstLabelId || row.id === secondLabelId
      )
    )
    .filter((pair) => pair.length === 2)
    .map((pair) => ({
      [firstLabelId]:
        pair[0].type === "time" ? pair[0].score : pair[0].primaryScore,
      [secondLabelId]:
        pair[1].type === "time" ? pair[1].score : pair[1].primaryScore,
    }));

  const xValues = values.map((value) => value[firstLabelId]);
  const yValues = values.map((value) => value[secondLabelId]);
  const analysis = correlationAnalysis(xValues, yValues);
  const maxXValue = Math.max(...xValues);
  const pointsOnLine = [
    {
      [firstLabelId]: 0,
      correlationLine: analysis.intercept,
    },
    {
      [firstLabelId]: maxXValue,
      correlationLine: analysis.slope * maxXValue + analysis.intercept,
    },
  ];
  //console.log(pointsOnLine);
  return (
    <React.Fragment>
      <ScatterAndLineOfBestFit
        data={[...values, ...pointsOnLine]}
        xId={firstLabelId}
        xLabel={firstLabelTitle}
        yId={secondLabelId}
        yLabel={secondLabelTitle}
        maxXValue={maxXValue}
      />
      <div style={{ padding: 8 }} />
      <Typography variant="body2">
        {t("moodboards.correlationHelp", {
          label1: firstLabelTitle,
          label2: secondLabelTitle,
          value: Math.round((analysis.C + Number.EPSILON) * 1000) / 1000,
        })}
      </Typography>
      <RegressionInfo
        category={t("moodboards.correlation")}
        analyses={[{ ...analysis, id: "", label: "" }]}
      />
    </React.Fragment>
  );
}

export default CorrelationBoard;
